import { createColumnHelper } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import Select from "react-select";
import DataTable from "../../../components/dataTable/DataTable";
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient";

export default function EscalasPage() {
    useEffect(() => {
        document.title = "Escalas | OB PORTUS";
        listarRegistros();
        // eslint-disable-next-line
    }, []);
    const [loading, setLoading] = useState<boolean>(false);
    const [dados, setDados] = useState<any[]>([]);
    const [dadosView, setDadosView] = useState<any[]>([]);

    const [escalaTipoFiltro, setEscalaTipo] = useState<any>({
        value: `0`,
        label: `Tipo`,
    });
    const optionsTiposEscalas: any[] = [
        {
            value: `1`,
            label: `Normal`,
        },
        {
            value: `2`,
            label: `12x36`,
        },
        {
            value: `3`,
            label: `Flexível`,
        },
        {
            value: `0`,
            label: `Todas Escalas`,
        },
    ];

    async function listarRegistros() {
        setLoading(true);
        const api = await reqGetNew(ApiEndpoints.pontoEscalas);
        if (api.status === 200) {
            setDados(api.data);
            setDadosView(api.data);
        }
        setLoading(false);
    }

    function handleChangeSituacao(choice: any) {
        setEscalaTipo(choice);
        const id_tipo = Number(choice.value);
        let dadosAux: any[] = [];
        for (let reg of dados) {
            if (id_tipo === 0) {
                dadosAux = dados;
                break;
            }
            switch (Number(reg.id_tipo)) {
                case 1:
                    if (id_tipo === 1) {
                        dadosAux.push(reg);
                    }
                    break;
                case 2:
                    if (id_tipo === 2) {
                        dadosAux.push(reg);
                    }
                    break;
                case 3:
                    if (id_tipo === 3) {
                        dadosAux.push(reg);
                    }
                    break;
            }
        }
        setDadosView(dadosAux);
    }

    function tableMiddleClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"));
        const reg: any = dadosView[idx];
        const link = `/ponto/escala/editar?id=${reg.id_escala}`;
        if (event.button === 1) {
            window.open(link);
        }
    }

    function tableClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"));
        const reg: any = dadosView[idx];
        const link = `/ponto/escala/editar?id=${reg.id_escala}`;
        if (event.button === 0) {
            window.location.assign(link);
        }
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <div className="div-row">
                    <h1 id="titleMain" style={{ marginRight: "10px" }}>
                        Escalas
                    </h1>
                    <Select
                        name="ids_tipos"
                        id="ids_tipos"
                        options={optionsTiposEscalas}
                        defaultValue={escalaTipoFiltro}
                        value={escalaTipoFiltro}
                        placeholder="Tipo"
                        onChange={(choice: any) => {
                            handleChangeSituacao(choice);
                        }}
                        styles={styleFiltroPequeno}
                    />
                </div>
                <div className="div-row">
                    <Button
                        onClick={() => {
                            window.location.assign(`/ponto/escala/cadastrar`);
                        }}
                    >
                        Cadastrar
                    </Button>
                </div>
            </div>
            <br></br>
            {loading && <Spinner />}
            {!loading && <DataTable dados={dadosView} tableSize={"auto"} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} defaultRows={50} />}
        </div>
    );
}

const columnHelper = createColumnHelper<any>();
const defaultColumns = [
    columnHelper.accessor((row) => row.codigo, {
        header: "Código",
        size: 50,
    }),
    columnHelper.accessor((row) => row.descricao_escala, {
        header: "Descrição",
        size: 250,
    }),
    columnHelper.accessor((row) => row.descricao_tipo, {
        header: "Tipo",
        size: 100,
    }),
];
const defaultOrder: any[] = [];

const styleFiltroPequeno = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        width: "250px",
        borderColor: "#dee2e6",
        minHeight: "39px",
        maxHeight: "120px",
        marginRight: "5px",
        fontSize: "14px",
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: "30px",
        maxHeight: "120px",
        overflowY: "auto",
        fontSize: "14px",
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        margin: "0px",
        fontSize: "14px",
    }),
    indicatorSeparator: (state: any) => ({
        display: "none",
        fontSize: "14px",
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: "39px",
        maxHeight: "120px",
        fontSize: "14px",
    }),
    menu: (provided: any, state: any) => ({
        ...provided,
        fontSize: "14px",
    }),
};
